class ModalDownloadMobileApp {
	
	/**
	 * Function for opening installed ios or android application or opening app stores
	 */
	static openAppStore() {
		const main = document.querySelector('.container-page');
		const mobileDevice = main.dataset.deviceType;
		const iosAppID = process.env.IOS_APP_ID;
		const androidAppID = process.env.ANDROID_APP_ID;
		
		const appID = (mobileDevice === 'Mobile Phone') ? androidAppID : iosAppID;
		
		const appURL = (mobileDevice === 'Mobile Phone') ? `intent://nperf.com/#Intent;scheme=nperf;package=${ appID };end` : `${ appID }://`;
		
		const fallbackURL = (mobileDevice === 'Mobile Phone') ? 'https://android.nperf.com/?s=popup_mobile' : 'https://ios.nperf.com/?s=popup_mobile';
		
		window.location.replace(appURL);
		
		setTimeout(function () {
			window.location = fallbackURL;
		}, 3000);
	}
	
	/**
	 * Function for putting matomo info and setting the session false when the modal is open
	 */
	static handleOnOpen() {
		sessionStorage.setItem('modalDownloadAppShown', 'false');
		
		const buttonModalMobileApp = document.querySelector('.btn-modal-download-app');
		buttonModalMobileApp.addEventListener('click', () => {
			ModalDownloadMobileApp.openAppStore();
			
			/* eslint-disable */
			_paq.push(['trackEvent', 'ModalMobileApp', buttonModalMobileApp.dataset.tag]);
			/* eslint-enable */
		});
	}
	
	/**
	 * Function for setting the session true when the modal would be closed by user
	 */
	static activeSession() {
		sessionStorage.setItem('modalDownloadAppShown', 'true');
	}
}

module.exports = ModalDownloadMobileApp;